function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_GOALMEMBERSTABBYGOALID_REQUEST = "GET_GOALMEMBERSTABBYGOALID_REQUEST";
export var GET_GOALMEMBERSTABBYGOALID_SUCCESS = "GET_GOALMEMBERSTABBYGOALID_SUCCESS";
export var GET_GOALMEMBERSTABBYGOALID_FAILURE = "GET_GOALMEMBERSTABBYGOALID_FAILURE";
export var RESET_GET_GOALMEMBERSTABBYGOALID = "RESET_GET_GOALMEMBERSTABBYGOALID";

// Fetches Members tabs for a particular currency code, member id and balance date from Front API.
// Relies on the custom API middleware defined in ../middleware/api.js.
export var fetchGoalMembersTabByGoalId = function fetchGoalMembersTabByGoalId(goalId) {
  return _defineProperty({
    goalId: goalId
  }, CALL_API, {
    types: [GET_GOALMEMBERSTABBYGOALID_REQUEST, GET_GOALMEMBERSTABBYGOALID_SUCCESS, GET_GOALMEMBERSTABBYGOALID_FAILURE],
    endpoint: "goalMembersTabs/search/findByGoalId".concat(urlSearchParams({
      goalId: goalId
    })),
    init: {
      credentials: "same-origin"
    }
  });
};